export default {
  getFleetSupplierBooking: (state) => state.fleetSupplierBooking,
};
